import { render } from "./TransactionAsideComponent.vue?vue&type=template&id=5c9f8197&scoped=true"
import script from "./TransactionAsideComponent.vue?vue&type=script&lang=js"
export * from "./TransactionAsideComponent.vue?vue&type=script&lang=js"

import "./TransactionAsideComponent.vue?vue&type=style&index=0&id=5c9f8197&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9f8197"]])

export default __exports__